// import i18n from '@/plugins/i18n'
import { api } from '@/util/api'

// 上傳檔案
export const upload = async (file) => {
  const mime = file.type.toLowerCase()
  let fileType = ''
  if (mime.startsWith('image/')) {
    fileType = 'image'
  } else if (mime.startsWith('video/')) {
    fileType = 'video'
  } else {
    fileType = 'file'
  }

  try {
    const formData = new FormData()
    formData.append('fileType', fileType)
    formData.append('module', 'admin')
    formData.append('category', 'post')
    formData.append('file', file)
    const { data } = await api.post('admin/file/upload', formData)
    return data.data
  } catch (err) {
    console.log('error', err)
  }
}
